export default __webpack_public_path__ + "static/media/m-beetstkermali.3d279770.png";